import React, { useState, useMemo } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import {
    renderTooltipHeader,
} from "../../dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";
import PropTypes from "prop-types";

const LevfinDealTrackerSummaryGrid = ({ summaryItem = {} }) => {
    const [summaryState, setSummaryState] = useState({ sort: [], filter: null });
    const gridData = useMemo(() => {
        if (!summaryItem) return [];
        return [summaryItem];
    }, [summaryItem]);

    if (!summaryItem) {
        return null;
    }

    return (
        <div className="summary-grid-wrapper">
            <Grid
                data={gridData}
                sort={summaryState.sort}
                filter={summaryState.filter}
                onSortChange={(e) => setSummaryState({ ...summaryState, sort: e.sort })}
                onFilterChange={(e) =>
                    setSummaryState({ ...summaryState, filter: e.filter })
                }
                className="levfin-time-log-summary-grid"
                resizable={true}
                filterable={false}
            >
                {summaryItem?.NumberOfDeals?.map((item, index) => (
                    <Column
                        field={`${item.Key}`}
                        title={renderTooltipHeader(`# of ${item.Key}`)}
                        cell={(props) => (
                            <td className="summary-cell k-table-td">
                                {item.Value ?? "—"}
                            </td>
                        )}
                    />
                ))}
                <Column
                    field="Total"
                    title={renderTooltipHeader("Total")}
                    cell={(props) => (
                        <td className="summary-cell k-table-td">
                            {props.dataItem.Total ?? "—"}
                        </td>
                    )}
                />

            </Grid>
        </div>
    );
};

LevfinDealTrackerSummaryGrid.propTypes = {
  summaryItem: PropTypes.shape({
    NumberOfDeals: PropTypes.arrayOf(
      PropTypes.shape({
        Key: PropTypes.string,
        Value: PropTypes.number,
      })
    ),
    Total: PropTypes.number,
  }),
};

export default LevfinDealTrackerSummaryGrid;